import { createItemFormFields } from '@routable/shared';
import { change } from 'redux-form';
import { formNamesItem } from 'constants/forms';
export const changeBillViewSelectedBillIndex = (index) => change(formNamesItem.CREATE_ITEM, createItemFormFields.UI_SELECTED_BILL_INDEX, index);
